import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Button, Card, EmptyState } from '@/components/ui';
import { PageContainer } from '@/layouts/PageContainer';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <PageContainer>
      <Card>
        <EmptyState
          title={t('errors.notFoundTitle')}
          body={t('errors.notFoundBody')}
          action={
            <Link to="/dashboard">
              <Button size="sm">Dashboard</Button>
            </Link>
          }
        />
      </Card>
    </PageContainer>
  );
}
